import { useDeleteAccountMutation } from "@/common/queries/queries";
import { Popup } from "@/components/popups/Popup";
import { BaseButton } from "@/components/buttons/BaseButton";
import "./style/DeleteAccount.scss";
import { showNotification } from "@/components/alerts/Notifications";

interface IDeleteAccountProps {
  isOpen: boolean;
  togglePopup: () => void;
}

export const DeleteAccount:React.FC<IDeleteAccountProps> = (props) => {
  const { isOpen, togglePopup } = props;
  const deleteAccountMutation = useDeleteAccountMutation();

  const handleDelete = async (): Promise<void> => {
    try {
      await deleteAccountMutation.mutateAsync();
      showNotification({
        variant: "success",
        title: "Please check your mailbox to continue."
      });
    } catch {
      showNotification({
        variant: "error",
        title: "Error deleting account, please try again in a few hours"
      });
    } finally {
      togglePopup();
    }
  };

  return (
    <Popup
      isOpen={isOpen}
      popupClass="DeleteAccount"
    >
      <p className="DeleteAccount-Description">
        {/* eslint-disable-next-line max-len */}
        By completing this process your account will be permanently deleted in the next 30 days. To proceed with removal, click "Confirm" and follow the instructions sent via email.
      </p>
      <BaseButton onClick={handleDelete} aria-label="confirm delete account">Confirm</BaseButton>
      <button onClick={togglePopup} className="DeleteAccount-CancelBtn" aria-label="cancel delete account">No Thanks, I'll Stay</button>
    </Popup>
  );
};
